export const CUSTOMER_CONVERSATION = {
  RESOLUTION: 'customer_conversation_resolution',
  CARE_FOLDER: 'customer_conversation_carefolder',
}
